export function calculateProbabilities(stocks: number[]): number[] {
  const totalStock = stocks.reduce((acc, stock) => acc + stock, 0);
  return stocks.map(stock => (stock / totalStock) * 100);
}
